import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
/**
 * Collapsed-by-default channel echo for a completed decision. Renders
 * the bridge's pre-baked Q+A content (KTK-194 follow-up) with no extra
 * Hub fetch — `decisionId` is kept on the prop so the card can switch
 * back to a `getDecision` fallback if the bridge ever needs to ship a
 * payload-less notification.
 */
export function DecisionCompletedCard({ decisionId: _id, content }) {
    const [expanded, setExpanded] = useState(false);
    const lines = content.split("\n");
    const summaryLine = lines[0] ?? content;
    const detail = lines.slice(1).join("\n").trim();
    const hasDetail = detail.length > 0;
    return (_jsxs("div", { style: cardStyle, children: [_jsxs("button", { type: "button", onClick: () => hasDetail && setExpanded((v) => !v), style: {
                    ...summaryBtnStyle,
                    cursor: hasDetail ? "pointer" : "default",
                }, "aria-expanded": expanded, disabled: !hasDetail, children: [_jsxs("span", { style: { fontSize: 13, color: "var(--text-primary)" }, children: ["\u2705 ", summaryLine] }), hasDetail && (_jsxs("span", { style: { fontSize: 11, color: "var(--text-muted)" }, children: [expanded ? "Hide" : "Show", " answers"] }))] }), expanded && hasDetail && (_jsx("pre", { style: detailStyle, children: detail }))] }));
}
const cardStyle = {
    marginTop: 4,
    border: "1px solid var(--border)",
    borderRadius: 6,
    background: "rgba(245, 159, 0, 0.05)",
    overflow: "hidden",
};
const summaryBtnStyle = {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 8,
    padding: "8px 12px",
    background: "transparent",
    border: "none",
    textAlign: "left",
    fontFamily: "inherit",
};
const detailStyle = {
    margin: 0,
    padding: "8px 12px 12px",
    borderTop: "1px solid var(--border)",
    fontFamily: "inherit",
    fontSize: 12,
    color: "var(--text-secondary)",
    lineHeight: 1.5,
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
};
//# sourceMappingURL=DecisionCompletedCard.js.map